export interface ValidationResult {
  valid: boolean;
  error?: string;
}

export function validateFullName(fullName: string): ValidationResult {
  if (!fullName.trim())
    return { valid: false, error: "Full name is required." };
  if (fullName.length < 2)
    return { valid: false, error: "Full name is too short." };
  return { valid: true };
}

export function validateEmail(email: string): ValidationResult {
  if (!email.trim()) return { valid: false, error: "Email is required." };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email))
    return { valid: false, error: "Invalid email address." };
  return { valid: true };
}

export function validatePhone(phone: string): ValidationResult {
  if (!phone.trim())
    return { valid: false, error: "Phone number is required." };
  if (!/^\d{6,15}$/.test(phone))
    return { valid: false, error: "Invalid phone number." };
  return { valid: true };
}

export function validatePassword(password: string): ValidationResult {
  if (!password) return { valid: false, error: "Password is required." };
  if (password.length < 6)
    return { valid: false, error: "Password must be at least 6 characters." };
  return { valid: true };
}

export function validateConfirmPassword(
  password: string,
  confirmPassword: string
): ValidationResult {
  if (!confirmPassword)
    return { valid: false, error: "Please confirm your password." };
  if (password !== confirmPassword)
    return { valid: false, error: "Passwords do not match." };
  return { valid: true };
}

export function validateSignupForm(fields: {
  fullName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
}): { [key: string]: ValidationResult } {
  return {
    fullName: validateFullName(fields.fullName),
    email: validateEmail(fields.email),
    phone: validatePhone(fields.phone),
    password: validatePassword(fields.password),
    confirmPassword: validateConfirmPassword(
      fields.password,
      fields.confirmPassword
    ),
  };
}
